function generateDateRanges() {
    const now = new Date();
  
    // Helper to format dates as YYYY-MM-DD
    const formatDate = (date) => date.toISOString().split('T')[0];
  
    // This week
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay()); // Sunday of this week
    startOfWeek.setHours(0, 0, 0, 0);
  
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday of this week
    endOfWeek.setHours(23, 59, 59, 999);
  
    // This month
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    endOfMonth.setHours(23, 59, 59, 999);
  
    // Last six months
    const startOfLastSixMonths = new Date(now);
    startOfLastSixMonths.setMonth(now.getMonth() - 6);
    startOfLastSixMonths.setDate(1);
    startOfLastSixMonths.setHours(0, 0, 0, 0);
  
    const endOfLastSixMonths = new Date(now);
    // endOfLastSixMonths.setDate(0); // Last day of the previous month
    // endOfLastSixMonths.setHours(23, 59, 59, 999);
  
    // Last year
    const startOfLastYear = new Date(now.getFullYear() - 1, now.getMonth(), now.getDay());
    const endOfLastYear = new Date(now);
    // endOfLastYear.setHours(23, 59, 59, 999);

    // Last three month
    const startOfThreeMonth = new Date(now.getFullYear(), now.getMonth() -3, now.getDay());
    const endOfThreeMonth = new Date(now);
  
    return {
      thisWeek: { start: formatDate(startOfWeek), end: formatDate(endOfWeek) },
      thisMonth: { start: formatDate(startOfMonth), end: formatDate(endOfMonth) },
      lastThreeMonths: { start: formatDate(startOfThreeMonth), end: formatDate(endOfThreeMonth) },
      lastSixMonths: {
        start: formatDate(startOfLastSixMonths),
        end: formatDate(endOfLastSixMonths),
      },
      lastYear: { start: formatDate(startOfLastYear), end: formatDate(endOfLastYear) },
    };
}
export {generateDateRanges};
  